import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var EmitterLife = /*#__PURE__*/function () {
  function EmitterLife() {
    _classCallCheck(this, EmitterLife);
    this.wait = false;
  }
  _createClass(EmitterLife, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.count !== undefined) {
        this.count = data.count;
      }
      if (data.delay !== undefined) {
        this.delay = data.delay;
      }
      if (data.duration !== undefined) {
        this.duration = data.duration;
      }
      if (data.wait !== undefined) {
        this.wait = data.wait;
      }
    }
  }]);
  return EmitterLife;
}();